import type { ReactNode } from 'react';

import { cssClasses } from 'pkg/css/utils';

import * as css from './styles.css';

interface Props {
	error?: boolean;
	testid?: string;
	children: ReactNode;
}

/**
 * InfoText component
 *
 * Displays informational or helper text with optional error styling.
 */

export function InfoText({ error, testid, children }: Props) {
	return (
		<span
			className={cssClasses(css.infoText, error && css.error)}
			data-testid={testid}>
			{children}
		</span>
	);
}
